export default __webpack_public_path__ + "static/media/alarm-clock_1760564.1b5e45ee.svg";